import {
  ConfirmModalArgs,
  useConfirmModal,
} from '@/components/ConfirmationModal';
import { useTranslation } from '@/i18n';
import { useMemo } from 'react';

export const useConfirmCancelEditModal = () => {
  const { t } = useTranslation();
  const args: ConfirmModalArgs = useMemo(
    () => ({
      title: t('ap_payee_detail_drawer_confirm_cancel_edit_modal_title'),
      body: t('ap_payee_detail_drawer_confirm_cancel_edit_modal_body'),
      cancelButtonProps: {
        isTertiary: true,
        children: t(
          'ap_payee_detail_drawer_confirm_cancel_edit_modal_cancel_button'
        ),
        testId:
          'ap-payee-detail-drawer-confirm-cancel-edit-modal-cancel-button',
      },
      okButtonProps: {
        isSecondary: true,
        color: 'danger',
        children: t(
          'transaction_items.detail.options.drawer.edit.cancel_confirm.button.cancel'
        ),
        testId:
          'ap-payee-detail-drawer-confirm-cancel-edit-modal-confirm-button',
      },
    }),
    [t]
  );
  return useConfirmModal(args);
};
